import { render, staticRenderFns } from "./tab-suporte.vue?vue&type=template&id=19a551a4&scoped=true&"
import script from "./tab-suporte.vue?vue&type=script&lang=js&"
export * from "./tab-suporte.vue?vue&type=script&lang=js&"
import style0 from "./tab-suporte.vue?vue&type=style&index=0&id=19a551a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a551a4",
  null
  
)

export default component.exports